/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_AutoInputs */

const fr_tab_auto = /** @type {(inputs: Tab_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montage automatique`)
};

const en_tab_auto = /** @type {(inputs: Tab_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto mount`)
};

/**
* | output |
* | --- |
* | "Auto mount" |
*
* @param {Tab_AutoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const tab_auto = /** @type {((inputs?: Tab_AutoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_AutoInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tab_auto(inputs)
	return en_tab_auto(inputs)
});